export class AuthorTypes {
    public static productManager = 1;
    public static devMember = 2;
    public static qeMember = 3;
    public static performanceMember = 4;
    public static teamMember = 5;
}



// WEBPACK FOOTER //
// ./src/app/common/data/authortypes.ts